/**
 * 週期結果問答／暫停本輪通知 API。
 */
import api from "@services/axios/apiManager";
import type { CycleOutcomeKind } from "@screen/Home/pages/HomePage/cycleOutcome.model";

export interface HomeCycleFeedback {
  kind: CycleOutcomeKind | null;
  cycle_anchor: string | null;
  should_show: boolean;
  surface: "inline" | "sheet" | null;
  paused: boolean;
  pause_reason: string | null;
  answered_today: boolean;
}

export interface HomeSurveyPrompt {
  needed: boolean;
  reason: "never" | "refresh" | null;
  completed_at: string | null;
  refresh_after_days: number;
}

export async function postCycleFeedback(args: {
  token: string;
  xContext: string;
  kind: CycleOutcomeKind;
  chipKey: string;
  note?: string;
  cycleAnchor?: string | null;
}): Promise<{ cycle_feedback: HomeCycleFeedback }> {
  const res = await api.post(
    "/app-api/customer/cycle-feedback",
    {
      kind: args.kind,
      chip_key: args.chipKey,
      note: args.note ?? null,
      cycle_anchor: args.cycleAnchor ?? undefined,
    },
    {
      headers: {
        Authorization: `Bearer ${args.token}`,
        "X-Context": args.xContext,
      },
    },
  );
  return res.data.data;
}

export async function postCyclePause(args: {
  token: string;
  xContext: string;
  reason: string;
  note?: string;
  kind?: CycleOutcomeKind | null;
  cycleAnchor?: string | null;
}): Promise<{ cycle_feedback: HomeCycleFeedback }> {
  const res = await api.post(
    "/app-api/customer/cycle-pause",
    {
      reason: args.reason,
      note: args.note ?? null,
      kind: args.kind ?? undefined,
      cycle_anchor: args.cycleAnchor ?? undefined,
    },
    {
      headers: {
        Authorization: `Bearer ${args.token}`,
        "X-Context": args.xContext,
      },
    },
  );
  return res.data.data;
}
